export const possibleTypes = {
    MediaItem: ["Image"],
};
